// The guided tour of My Benefits, one of the four My Info pages.
//
// Every step is gated on inBenefitsScheme, which is the same flag the page
// renders the scheme by: permanent and fixed-term employees are in it, and a
// contractor sees one sentence on this page; a tour of the points they do not
// have would be a tour of nothing, and the engine finishes a tour with no
// visible steps rather than opening it, so for them it never appears. Steps point at [data-tour] anchors on people/MyInfoPage.jsx. The
// Select Benefits button and the coming-year panel only render in the right
// conditions, so those bodies are written to read standalone. The Standard
// Benefits section lists only the ones the person qualifies for and is hidden
// while there are none, and its step is gated on hasStandardBenefits, the same
// fact the page draws it from.

export const MY_BENEFITS_TOUR_ID = 'my-benefits';

export const myBenefitsTourSteps = [
  {
    title: 'Welcome to My Benefits',
    when: (c) => c.inBenefitsScheme,
    body: [
      'This page has two kinds of benefit. Flexible benefits are chosen once a year and paid for in points: your points, what you have chosen, and, during February, the choice for the year ahead. Standard benefits, further down when you qualify for any, are yours as an employee, with nothing to choose.',
      'Use Next (or the arrow keys) to walk through, or Skip if you would rather explore. It will not pop up again either way.',
    ],
  },
  {
    title: 'Your points',
    target: '[data-tour="benefits-points"]',
    when: (c) => c.inBenefitsScheme,
    body: [
      'The benefit year runs from 1 March to the end of February. Your points for it are set by the quarter you joined in, so a new joiner part way through the year gets a pro-rated share; HR can set a different figure, and the box says so when they have.',
      'Points Remaining is what you still have to spend. Points do not carry over.',
    ],
  },
  {
    title: 'Choosing your benefits',
    target: '[data-tour="benefits-select"]',
    when: (c) => c.inBenefitsScheme,
    body: [
      'Select Benefits appears while you have points and nothing chosen yet. It opens a list of everything on offer with its cost; add what you want until the points run out, then submit.',
      'Your choice goes to HR for approval. While it is with them, a banner here says so, and the benefits appear in the table once approved.',
    ],
  },
  {
    title: 'Fixed once chosen',
    target: '[data-tour="benefits-active"]',
    when: (c) => c.inBenefitsScheme,
    body: [
      'Your active benefits for the year, with what each cost and when it started. Once a selection is in place it cannot be revised from here: flexible benefits are fixed for the year, and there is no button because the change is not possible.',
      'If something genuinely needs to change, speak to HR.',
    ],
  },
  {
    title: 'The year ahead, in February',
    target: '[data-tour="benefits-next-year"]',
    when: (c) => c.inBenefitsScheme,
    body: [
      'Through February a second panel appears for the year starting 1 March, with the points you will have and a button to choose. Choose then, so HR can approve before the year begins and the benefits are in place from day one.',
      'Outside February the panel is not shown, and the current year is all there is.',
    ],
  },
  {
    title: 'Standard benefits',
    target: '[data-tour="benefits-standard"]',
    when: (c) => c.inBenefitsScheme && c.hasStandardBenefits,
    body: [
      'Benefits you have as an employee, outside the points scheme. Each card says what it is, who qualifies and how to use it.',
      'Only the benefits you qualify for today are listed. Some depend on length of service or on passing probation, and those appear here once you have.',
    ],
  },
  {
    title: 'The rules in short',
    target: '[data-tour="benefits-reminders"]',
    when: (c) => c.inBenefitsScheme,
    body: [
      'For flexible benefits: use it or lose it within the year; each benefit once a year except Extra Annual Leave; no cash alternative; and where receipts are needed, only costs from after you selected the benefit count.',
      'The "?" beside the page title replays this tour any time.',
    ],
  },
];
